// React Basic and Bootstrap
import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      features: [
        {
          icon: 'uil uil-browser h1 text-primary',
          title: "Коробочное решение",
          desc: "Коробочное решение для автоматизации или создания бизнеса",
          link: "#",
        },
        {
          icon: 'uil uil-cloud-computing h1 text-primary',
          title: "Облачное решение",
          desc: "Быстрый доступ к Вашим данным: товары, заказы, клиенты",
          link: "#",
        },
        {
          icon: 'uil uil-server h1 text-primary',
          title: "Автоматизация работы",
          desc: "Автоматическая обработка клиента и заказа",
          link: "#",
        },
        {
          icon: 'uil uil-server-network h1 text-primary ',
          title: "Не требуется знаний",
          desc: "От Вас не потребуется технических знаний и навыков",
          link: "#",
        },
        {
          icon: 'uil uil-database-alt h1 text-primary',
          title: "Хранение данных",
          desc: "Ваши данные буду храниться на серверах, потери исключены",
          link: "#",
        },
        {
          icon: 'uil uil-message h1 text-primary',
          title: "Быстрые уведомления",
          desc: "Получайте уведомления о заказах и клиентах быстро и так как Вам удобно",
          link: "#",
        },
        {
          icon: 'uil uil-channel-add h1 text-primary',
          title: "Интеграция с бизнесом",
          desc: "Инстеграция с CRM, складом, бухгалтерией и платежной системой",
          link: "#",
        },
        {
          icon: 'uil uil-instagram h1 text-primary',
          title: "Социальные сети",
          desc: "Тесная связь с социальными сетями Вашей компании",
          link: "#",
        },
        {
          icon: 'uil uil-assistive-listening-systems h1 text-primary',
          title: "Надежная поддержка",
          desc: "Узнаем важные для бизнеса детали и внимательно их прорабатываем",
          link: "#",
        },
        ////////////////
        // {
        //   icon: 'uil uil-code-branch h1 text-primary',
        //   title: "Внедрение ERP-систем",
        //   desc: "Облачная платформа для управления ресурсами предприятия без затрат на инфраструктуру",
        //   link: "#",
        // },
        // {
        //   icon: 'uil uil-code-branch h1 text-primary',
        //   title: "Разработка мобильных приложений",
        //   desc: "Быстрые и красивые приложения на платформах iOS и Android для вашего бизнеса и стартапа",
        //   link: "#",
        // },
        // {
        //   icon: 'uil uil-code-branch h1 text-primary',
        //   title: "Разработка сайтов",
        //   desc: "Анализ бизнес-процессов, разработка дизайна, удобная система управления – все, что нужно для эффективного сайта",
        //   link: "#",
        // },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section">
          <Container className="pb-lg-4 mb-md-5 mb-4">
            <Row className="align-items-center mb-4">
              <Col lg="12" md="12" className="text-sm-start">
                <div className="section-title">
                  <h4 className="title mb-4">Облачное решение</h4>
                  {/* <p className="text-muted para-desc mb-0">
                    Start working with{" "}
                    <span className="text-primary fw-bold">
                      Landrick
                    </span>{" "}
                    that can provide everything you need to generate awareness,
                    drive traffic, connect.
                  </p> */}
                </div>
              </Col>

              {/* <Col
                lg="3"
                md="4"
                className="mt-4 mt-sm-0 text-sm-end pt-2 pt-sm-0"
              >
                <Link to="#" className="btn btn-outline-primary">
                  Read more <i className="mdi mdi-chevron-right"></i>
                </Link>
              </Col> */}
            </Row>

            <Row>
              {this.state.features.map((feature, key) => (
                <Col lg="4" md="6" xs="12" className="mt-5 pt-3" key={key}>
                  <div className="features">
                    <div className="image position-relative d-inline-block">
                      <i className={feature.icon}></i>
                    </div>

                    <div className="content mt-4">
                      <h5 className="title-2">{feature.title}</h5>
                      <p className="text-muted">{feature.desc}</p>
                      {/* <Link to={feature.link} className="text-primary">
                        Read more <i className="mdi mdi-chevron-right"></i>
                      </Link> */}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <div className="position-relative">
          <div className="shape overflow-hidden text-light">
            <svg
              viewBox="0 0 2880 250"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M720 125L2160 0H2880V250H0V125H720Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Services;
